import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import './style.css';

import commonFunctions from '../../../commonFunctions';
import * as ariBnbConsts from './const';

/**
 * https://github.com/airbnb/react-dates
 */
class AirBnbDateTimePicker extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            focused: false,
            value: this.props.value,
            displayFormat: 'DD-MM-YYYY'
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.value !== prevState.value)
            return Object.assign({}, prevState, { value: nextProps.value });
        return null;
    }

    isDayBlocked = (day) => {
        if (this.props.isDayBlocked)
            return this.props.isDayBlocked(day);

        return false;
    }

    onDateChange = (date) => {
        if (!_.isNil(date) && commonFunctions.isValidDate(date.toDate()))
            this.props.onChange({
                target: {
                    name: this.props.name,
                    value: date.toISOString()
                }
            });
        else
            this.props.onChange({
                target: {
                    name: this.props.name,
                    value: null
                }
            });
    }

    onFocusChange = (param) => {
        this.setState({ focused: param.focused });
    }

    isDayHighlighted = (a, b) => {
        return a.toISOString() === a._i;
    }

    validation = (value) => {
        if (this.props.validate && !this.props.validate(value)) {
            if (!_.isNil(this.props.errorMessage) && !_.isEmpty(this.props.errorMessage))
                return this.props.errorMessage;
            return 'Validazione non rispettata';
        }
        else if (this.props.required && _.isEmpty(value)) {
            if (!_.isNil(this.props.errorMessage) && !_.isEmpty(this.props.errorMessage))
                return this.props.errorMessage;
            return 'Campo obbligatorio';
        }
    }

    render() {
        var date = new Date(this.state.value);
        if (!_.isNil(this.state.value) && commonFunctions.isValidDate(date))
            date = moment(this.state.value);
        else
            date = null;

        const resultErrorMessage = this.validation(this.state.value);

        return (
            <div className='formComponent'>
                <div className='input-group'>
                    {this.props.label ? <label className='input-group-addon' htmlFor={this.props.name}>{this.props.label}</label> : ''}
                    <SingleDatePicker
                        id={this.props.name}
                        date={date}
                        isDayBlocked={this.isDayBlocked}
                        numberOfMonths={this.props.numberOfMonths ? this.props.numberOfMonths : 1}
                        readOnly={false}
                        disabled={this.props.disabled}
                        required={this.props.required}
                        focused={this.state.focused}
                        onDateChange={this.onDateChange}
                        onFocusChange={this.onFocusChange}
                        displayFormat={this.state.displayFormat}
                        placeholder={_.isNil(this.props.placeholder) ? this.props.label : this.props.placeholder}
                        isDayHighlighted={this.isDayHighlighted}
                        phrases={ariBnbConsts.SingleDatePickerPhrases}
                        isOutsideRange={this.props.isOutsideRange ? () => this.props.isOutsideRange : () => false}
                        showClearDate
                        small
                    />
                </div>
                {resultErrorMessage !== '' && <div style={{ color: '#a94442' }}>{resultErrorMessage}</div>}
            </div>
        );
    }
}

AirBnbDateTimePicker.propTypes = {
    disabled: PropTypes.bool,
    errorMessage: PropTypes.string,
    isOutsideRange: PropTypes.func,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    numberOfMonths: PropTypes.number,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    validate: PropTypes.func,
    value: PropTypes.string
};

export default AirBnbDateTimePicker;
